import { useEffect, useRef } from 'react'

import cn from 'classnames'

import { IExchangePairChartProps } from './exchange-price-chart.props'
import styles from './styles.module.scss'

export default function ExchangePriceChart({ fromCurrency, toCurrency, className }: IExchangePairChartProps) {
  const widgetRef = useRef(null)
  useEffect(() => {
    widgetRef.current.innerHTML = ''
    const script = document.createElement('script')
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js'
    script.async = true
    script.innerHTML = `{
		  "symbol": "${toCurrency.ticker.toUpperCase()}${fromCurrency.ticker.toUpperCase()}",
		  "width": "100%",
		  "height": "100%",
		  "locale": "en",
		  "dateRange": "12M",
		  "colorTheme": "light",
		  "trendLineColor": "rgba(255, 149, 7, 1)",
		  "underLineColor": "rgba(246, 178, 107, 0.78)",
		  "underLineBottomColor": "rgba(249, 203, 156, 0)",
		  "isTransparent": false,
		  "autosize": false,
		  "largeChartUrl": ""
		}`
    widgetRef.current.appendChild(script)
  }, [fromCurrency.ticker])

  return (
    <div className={cn(styles.chart, className)}>
      <div className="tradingview-widget-container" ref={widgetRef}></div>
    </div>
  )
}
